import { Spin } from 'antd'
import { useTranslation } from 'react-i18next'

import { GetTotalWashingCountByRangeDayResponse } from '@/types/apis/washingCount/GetTotalWashingCountByRangeDayResponse'
import { formatJapaneseNumber } from '@/utils/formatPrice'

import { ContainerTable, DataCellWrapper, HeaderCellWrapper, TableCustom, TableWrapper, Wrappertable } from '../styles'

type Props = {
  responseTotalWashingCount: GetTotalWashingCountByRangeDayResponse
  responseTotalWashingCountLoading?: boolean
}

const TotalWashingCountByRangeDayTable = ({ responseTotalWashingCount, responseTotalWashingCountLoading }: Props) => {
  const { t } = useTranslation()
  const dataSource = responseTotalWashingCount.items

  return (
    <ContainerTable>
      <Spin spinning={responseTotalWashingCountLoading}>
        <TableWrapper>
          <Wrappertable>
            <TableCustom>
              <tbody>
                <tr>
                  {dataSource?.map((item, index) => (
                    <HeaderCellWrapper key={index}>{item.name}</HeaderCellWrapper>
                  ))}

                  <HeaderCellWrapper>{t('components.pages.washingCount.listReport.table.total')}</HeaderCellWrapper>
                </tr>
                {dataSource.length ? (
                  <tr>
                    {dataSource?.map((item, index) => (
                      <DataCellWrapper key={index}>{formatJapaneseNumber(item.count)}</DataCellWrapper>
                    ))}
                    <DataCellWrapper>{formatJapaneseNumber(responseTotalWashingCount.totalCount)}</DataCellWrapper>
                  </tr>
                ) : null}
              </tbody>
            </TableCustom>
          </Wrappertable>
        </TableWrapper>
      </Spin>
    </ContainerTable>
  )
}
TotalWashingCountByRangeDayTable.displayName = 'TotalWashingCountByRangeDayTable'
export default TotalWashingCountByRangeDayTable
